'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _RoleTypes = require('conversations-schema/constants/RoleTypes');

var _RoleTypes2 = _interopRequireDefault(_RoleTypes);

var _Responder = require('conversations-schema/records/Responder');

var _Responder2 = _interopRequireDefault(_Responder);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function SenderName(_ref) {
  var currentRole = _ref.currentRole,
      messageRole = _ref.messageRole,
      responder = _ref.responder;
  var firstName = responder.firstName,
      lastName = responder.lastName;

  var inVisitorUi = currentRole === _RoleTypes2.default.VISITOR;

  var visitorMessageInVisitorUi = inVisitorUi && messageRole === _RoleTypes2.default.VISITOR;

  var displayNothing = visitorMessageInVisitorUi || !firstName;
  var displayOnlyFirstName = inVisitorUi || !lastName;

  if (displayNothing) {
    return null;
  }

  var nameString = displayOnlyFirstName ? firstName : firstName + ' ' + lastName;

  return _react2.default.createElement(
    'b',
    { className: 'm-right-1' },
    nameString
  );
}

SenderName.propTypes = {
  messageRole: _react.PropTypes.oneOf(Object.keys(_RoleTypes2.default)).isRequired,
  currentRole: _react.PropTypes.oneOf(Object.keys(_RoleTypes2.default)).isRequired,
  responder: _react.PropTypes.instanceOf(_Responder2.default).isRequired
};

exports.default = SenderName;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-conversations/static-1.133/js/components/SenderName.js
// module id = 404
// module chunks = 0 1